export const appIdentity = {
  macOSSite: 'com.macpaw.clearvpn.macos-site-ver',
  chromeAdBlock: 'com.macpaw.clearvpn.extension.chrome.adblock',
  cabinet: 'my.clearvpn.com',
  orderDefault: 'order.clearvpn.com',
  orderAffiliate: 'clearvpn2.affiliate',
  orderAffiliateTrials: 'clearvpn2.affiliate.trials',
  orderInfluencers: 'clearvpn2.influencer',
} as const;

export type OneOfAppIdentities = (typeof appIdentity)[keyof typeof appIdentity];
